import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';

@Component({
  selector: 'app-order-period-select',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './order-period-select.component.html',
  styleUrl: './order-period-select.component.scss'
})
export class OrderPeriodSelectComponentComponent implements OnInit {
  @Input() reload: boolean = false;

  modalTitle: string = 'Periode koppelen';
  modalStyle: boolean = false;

  loading: boolean = false;

  @Input() item: any = {  };
  periodList: any[] = [];

  constructor(
    private apiService: ApiService, 
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getPeriods();
  }

  setItem (item: any) {
    this.item = item;
    this.getPeriods();
  }

  getPeriods() {
    this.loading = true;
    this.apiService.get('/office/periods?limit=50000&sort=name&direction=asc')
      .then((response: any) => {
        this.periodList = response.data.map((period: any) => ({
          ...period,
        }));
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }

  select(id:string) {
    let self = this;
    this.loading = true;
    this.apiService.patch("/office/orders/" + this.item['id'], {
      period_id: id
    }).then(function (response: any) {
      self.activeModal.close(true);
      self.loading = false;
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
